import { apiGetMensajes, apiMarcarComoLeido } from '@/library/api/mensajeria';

export default {
	namespaced: true,
	actions:{
		async getMensajes({commit, state}, payload={}){
			commit('GET_MENSAJES', true);
			try{
				
				let {contribuyente, username, refresh} = payload;
				if( !refresh && !state.estado ){
					commit('END_GET_MENSAJES');
					return;
				}

				let body = await apiGetMensajes(contribuyente, username);

				// const {mensajes, total} = body;

				commit('SET_MENSAJES', body);
				return body;
			}catch(e){
				commit('SET_ERROR', e);
			}finally{
				commit('END_GET_MENSAJES');
			}
		},
		/**
		 * @param {object} payload
		 * @param {payload.string} usuario 
		 * @param {payload.number} contribuyente 
		 * @param {payload.array} opcion
		 * @param {payload.grupo} grupo
		 * @param {payload.hash} hash
		 */
		async marcarComoLeido({commit, state, dispatch, getters, rootState}, payload){
			
			const {usuario, contribuyente, mensaje, respuestas} = payload;

			try{
					
				if( state.mensajes.filter(m=>!m.leido).length > 1 ){
					commit('MARCAR_LEYENDO', mensaje)
				}else{
					mensaje.loading = true;
				}

				let resp = await apiMarcarComoLeido(
					mensaje.grupo_identificador,
					usuario, contribuyente, 
					mensaje.hash, respuestas);

				const MIN_MSJS = 35
					
				if( resp == true ){
					commit('MARCAR_LEIDO', mensaje)
					if( state.mensajes.length < MIN_MSJS 
						&& state.total > MIN_MSJS 
						&& getters['cantidadMensajesSinLeer'] > state.mensajes.length
						&& !getters['loading']
					){
						dispatch('getMensajes',{
							username: rootState.usuario.username,
							contribuyente: rootState.empresas.selected.rut,
						});
					}
				}else{
					commit('DESMARCAR_LEIDO', mensaje)
				}
				
			}catch(e){
				console.error(e)
				commit('DESMARCAR_LEIDO', mensaje)
			}finally{
				mensaje.loading = false;
			}
		},
		async getTopicoCotnribuyente({}, payload){
			
		}
	},
	mutations:{
		GET_MENSAJES: (state, loading)=>{
			state.ultimaLlamada = new Date().getTime();
			state.estado = 'LOADING';
		},
		SET_MENSAJES: (state, {mensajes, total})=>{
			state.mensajes = mensajes;
			state.total = isNaN(parseInt(total))?0:parseInt(total);
		},
		SET_ERROR: (state, error)=>{
			state.error = error;
			state.estado = 'ERROR';
		},
		END_GET_MENSAJES: (state)=>{
			if( state.estado !== 'ERROR' )	state.estado = 'OK';
		},
		MARCAR_LEYENDO: (state, mensaje)=>{
			const findFunc = (m)=>m.hash == mensaje.hash && m.grupo == mensaje.grupo;
			const msj = (state.mensajes.find(findFunc)||{});
			const index = state.mensajes.findIndex(findFunc)
			msj.loading = true;
			if( state.mensajes.filter(m=>!m.leido).length > 1 ){
				let a = state.mensajes.splice(index, 1);
				msj.leido = true;
			}
			
			return msj;
		}
		,DESMARCAR_LEIDO: (state, mensaje)=>{
			const findFunc = (m)=>m.hash == mensaje.hash && m.grupo == mensaje.grupo;
			const index = state.mensajes.findIndex(findFunc)
			
			if( index === -1 )	state.mensajes.push(mensaje)
			const msj = (state.mensajes.find(findFunc)||{})
			msj.leido = false;
			msj.loading = false;
			return msj;
		}
		,MARCAR_LEIDO: (state, mensaje)=>{
			const findFunc = (m)=>m.hash == mensaje.hash && m.grupo == mensaje.grupo;
			const index = state.mensajes.findIndex(findFunc)
			if( index != -1 ){
				
				state.mensajes[index].leido = true;
				let a = state.mensajes.splice(index, 1);
				// return state.mensajes[index];
			}
			state.total--;
			return false;
		}
		,MARCAR_RESPUESTA: (state, payload)=>{
			const { 
				grupo, hashMensaje, opcionTipo
				, opcionTexto, respuesta
			} = payload;
			let mensaje = state.mensajes
				.find(m=>m.hash == hashMensaje && m.grupo == grupo);
			
			if( mensaje == null )	return;

			const opc = Object.values(mensaje.opciones)
				.find(o=>o.tipo===opcionTipo && o.texto===opcionTexto)
			
			opc.respuesta = respuesta;
		}
		,MARCANDO_LECTURA(state, mensaje){
			const msj = (state.mensajes
				.find(m=>m.hash == mensaje.hash && m.grupo == mensaje.grupo)
				||{}).leido = true
			return msj;
		}
	},
	getters:{
		mensajes(state){return state.mensajes;},
		loading:(state)=>state.estado === 'LOADING',
		mensajesNoLeidos:(state)=>state.mensajes.filter(m=>!m.leido),
		tieneMensajesSinLeer:(state, getters)=>getters.mensajesNoLeidos.length > 0,
		cantidadMensajesSinLeer:(state)=>state.total,
	},
	state:() => ({
		mensajes:[],
		total: null,
		estado: undefined,
		error:null,
		ultimaLlamada: null,
	}),
}